module.exports = __webpack_public_path__ + "staticcomp/img/cover.96fe9ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/12/cover.jpg
// module id = Iswf
// module chunks = 39